import dayjsTZ from "../../../utils/dayjs";
import {
  getTicketStatusMeta,
  toMessagePreview,
} from "./utils/ticketStatus";

function TicketList({
  tickets,
  selectedId,
  onSelect,
  search,
  onSearchChange,
  statusFilter,
  onStatusFilter,
  statusCounts,
}) {
  return (
    <aside className="supportTicketList">
      <div className="supportTicketList__search">
        <input
          type="search"
          placeholder="Kërko ticket..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <div className="supportTicketList__filters">
        <button
          type="button"
          className={!statusFilter ? "is-active" : ""}
          onClick={() => onStatusFilter("")}
        >
          Të gjitha
        </button>
        {(statusCounts || []).map((s) => (
          <button
            type="button"
            key={s.value}
            className={statusFilter === s.value ? "is-active" : ""}
            style={{
              borderColor: s.backgroundColor,
            }}
            onClick={() =>
              onStatusFilter(statusFilter === s.value ? "" : s.value)
            }
          >
            {s.label}
            <span>{s.count}</span>
          </button>
        ))}
      </div>
      <ul className="supportTicketList__items">
        {tickets.map((ticket) => {
          const statusMeta = getTicketStatusMeta(ticket.ticketStatus);
          const preview =
            ticket.lastMessagePreview ||
            toMessagePreview(ticket.ticketDescription);
          const when = ticket.lastMessageAt || ticket.createdAt;
          return (
            <li key={ticket.ticketId}>
              <button
                type="button"
                className={`supportTicketList__item ${
                  selectedId === ticket.ticketId ? "is-selected" : ""
                }`}
                onClick={() => onSelect(ticket)}
              >
                <div className="supportTicketList__itemTop">
                  <strong>{ticket.createdBy || "—"}</strong>
                  <span
                    className="supportTicketList__badge"
                    style={{
                      backgroundColor: statusMeta.backgroundColor,
                      color: statusMeta.color,
                    }}
                  >
                    {statusMeta.label}
                  </span>
                </div>
                <div className="supportTicketList__category">
                  {ticket.ticketCategory}
                </div>
                <div className="supportTicketList__preview">{preview}</div>
                <div className="supportTicketList__time">
                  {when ? dayjsTZ(when).format("DD/MM/YYYY HH:mm") : ""}
                </div>
              </button>
            </li>
          );
        })}
        {!tickets.length && (
          <li className="supportTicketList__empty">Nuk ka tickets.</li>
        )}
      </ul>
    </aside>
  );
}

export default TicketList;
